import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=0f543a86&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f543a86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f543a86')) {
      api.createRecord('0f543a86', component.options)
    } else {
      api.reload('0f543a86', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=0f543a86&scoped=true&", function () {
      api.rerender('0f543a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hc/returned-money/edit.vue"
export default component.exports